export const pobyt = {
  pob: [
    "Dowolny",
    "Do 5 dni",
    "Tydzień",
    "Więcej niż tydzień",
    "Dwa tygodnie",
    "Więcej niż 14 dni"
  ],
  pobvals: ["", "1,5", "6,8", "9,12", "13,15", "16,50"]
};
